import type { Manifest } from "@powerhousedao/shared/document-model";
import manifestJson from "./powerhouse.manifest.json" with { type: "json" };
export { documentModels } from "./document-models/document-models.js";
export { editors } from "./editors/editors.js";
export const manifest: Manifest = manifestJson;
